import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import PropTypes from "prop-types";

/**
 * Componente reutilizável para alertas customizável pré-configurado para duas opções
 */
function OptionsSwal({
  title = null,
  icon = null,
  confirmButtonColor = "#34c38f",
  confirmButtonText = "Sim",
  denyButtonColor = "#f46a6a",
  denyButtonText = "Não",
  text = null,
  html = null,
  ...props
}) {
  const MySwal = withReactContent(Swal);

  return MySwal.fire({
    title: title,
    text: text,
    html: html,
    icon: icon,
    showConfirmButton: true,
    showDenyButton: true,
    confirmButtonText: confirmButtonText,
    denyButtonText: denyButtonText,
    confirmButtonColor: confirmButtonColor,
    denyButtonColor: denyButtonColor,
    ...props,
  });
}

OptionsSwal.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.oneOf(["success", "error", "warning", "info", "question"])
    .isRequired,
  confirmButtonColor: PropTypes.string,
  confirmButtonText: PropTypes.string,
  denyButtonColor: PropTypes.string,
  denyButtonText: PropTypes.string,
  text: PropTypes.string,
  html: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default OptionsSwal;
